module.exports = __webpack_public_path__ + "static/media/cycling-icon.6b8c3568.webp";